import { API_GET } from "../config/axiosConfig";

const COREAPIANALYTICSURL = `${process.env.REACT_APP_CORE_API_URI}/web/events`;
const COREAPIURLTAGS = `${process.env.REACT_APP_CORE_API_URI}/web/clients`;

export async function getTotalCountData(startDate, endDate, selectedClientTag) {
    try {
        let url;
        if (selectedClientTag !== "" && selectedClientTag !== "intraverse") {
            url = `${COREAPIANALYTICSURL}/users/stats?startDate=${startDate}&endDate=${endDate}&clientTag=${selectedClientTag}`;
        } else {
            url = `${COREAPIANALYTICSURL}/users/stats?startDate=${startDate}&endDate=${endDate}`;
        }
        const response = await API_GET(url);

        if (response.status === 200) return response.data;
        return [];
    } catch (error) {
        console.error("Error during getTotalCountData fetch:", error);
        return [];
    }
}

export async function getClientTags() {
    try {
        const response = await API_GET(`${COREAPIURLTAGS}/client-tags`);
        if (response.status === 200) return response.data.clientTags;
        return [];
    } catch (error) {
        console.error("Error during getClientTags fetch:", error);
        return [];
    }
}

export async function getBrandsData(startDate, endDate, selectedClientTag) {
    try {
        let url;
        if (selectedClientTag !== "" && selectedClientTag !== "intraverse") {
            url = `${COREAPIANALYTICSURL}/brands/stats?startDate=${startDate}&endDate=${endDate}&clientTag=${selectedClientTag}`;
        } else {
            url = `${COREAPIANALYTICSURL}/brands/stats?startDate=${startDate}&endDate=${endDate}`;
        }
        const response = await API_GET(url);

        if (response.status === 200) {
            return response.data;
        }
        return [];
    } catch (error) {
        console.error("Error during getBrandsData fetch:", error);
        return [];
    }
}

export async function getCategoriesData(startDate, endDate, selectedClientTag) {
    try {
        let url;
        if (selectedClientTag !== "" && selectedClientTag !== "intraverse") {
            url = `${COREAPIANALYTICSURL}/categories/stats?startDate=${startDate}&endDate=${endDate}&clientTag=${selectedClientTag}`;
        } else {
            url = `${COREAPIANALYTICSURL}/categories/stats?startDate=${startDate}&endDate=${endDate}`;
        }
        const response = await API_GET(url);

        if (response.status === 200) {
            return response.data;
        }
        return [];
    } catch (error) {
        console.error("Error during getCategoriesData fetch:", error);
        return [];
    }
}

export async function getInteractionData(startDate, endDate, selectedClientTag) {
    try {
        let url;
        if (selectedClientTag !== "" && selectedClientTag !== "intraverse") {
            url = `${COREAPIANALYTICSURL}/interactions/stats?startDate=${startDate}&endDate=${endDate}&clientTag=${selectedClientTag}`;
        } else {
            url = `${COREAPIANALYTICSURL}/interactions/stats?startDate=${startDate}&endDate=${endDate}`;
        }
        const response = await API_GET(url);

        if (response.status === 200) {
            return response.data;
        }
        return [];
    } catch (error) {
        console.error("Error during interactions fetch:", error);
        return [];
    }
}

export async function getLinkoutsData(startDate, endDate, selectedClientTag) {
    try {
        let url;
        if (selectedClientTag !== "" && selectedClientTag !== "intraverse") {
            url = `${COREAPIANALYTICSURL}/linkouts/stats?startDate=${startDate}&endDate=${endDate}&clientTag=${selectedClientTag}`;
        } else {
            url = `${COREAPIANALYTICSURL}/linkouts/stats?startDate=${startDate}&endDate=${endDate}`;
        }
        const response = await API_GET(url);
        if (response.status === 200) {
            return response.data;
        }
        return [];
    } catch (error) {
        console.error("Error during interactions fetch:", error);
        return [];
    }
}

export async function getDevicesData(startDate, endDate, selectedClientTag) {
    try {
        let url;
        if (selectedClientTag !== "" && selectedClientTag !== "intraverse") {
            url = `${COREAPIANALYTICSURL}/device-logs?startDate=${startDate}&endDate=${endDate}&clientTag=${selectedClientTag}`;
        } else {
            url = `${COREAPIANALYTICSURL}/device-logs?startDate=${startDate}&endDate=${endDate}`;
        }
        const response = await API_GET(url);
        if (response.status === 200) {
            return response.data;
        }
        return [];
    } catch (error) {
        console.error("Error during interactions fetch:", error);
        return [];
    }
}

export async function getAvatarsData(startDate, endDate, selectedClientTag) {
    try {
        let url;
        if (selectedClientTag !== "" && selectedClientTag !== "intraverse") {
            url = `${COREAPIANALYTICSURL}/avatars/stats?startDate=${startDate}&endDate=${endDate}&clientTag=${selectedClientTag}`;
        } else {
            url = `${COREAPIANALYTICSURL}/avatars/stats?startDate=${startDate}&endDate=${endDate}`;
        }
        const response = await API_GET(url);
        if (response.status === 200) {
            return response.data;
        }
        return [];
    } catch (error) {
        console.error("Error during interactions fetch:", error);
        return [];
    }
}

export async function getRoomOwnersByClientTag(userId) {
    try {
        const url = `${COREAPIURLTAGS}/client-tags/rooms/owners/${userId}`;

        const response = await API_GET(url);
        if (response.status === 200) {
            return response.data;
        }
        return false;
    } catch (error) {
        console.error("Error during getRoomOwnersByClientTag fetch:", error);
        return false;
    }
}
